let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lCdlK")).then(() => parcelRequire('d2onE'));